import { render, staticRenderFns } from "./RecommenderModal.vue?vue&type=template&id=7356174e&scoped=true"
import script from "./RecommenderModal.vue?vue&type=script&lang=js"
export * from "./RecommenderModal.vue?vue&type=script&lang=js"
import style0 from "./RecommenderModal.vue?vue&type=style&index=0&id=7356174e&prod&lang=scss&scoped=true"
import style1 from "./RecommenderModal.vue?vue&type=style&index=1&id=7356174e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7356174e",
  null
  
)

export default component.exports